import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { Document } from "../domain/document"
import { AttachedFile } from "../domain/attachedFile";
import { EDocumentType } from "../model/enum/documentType";
import { EurodatKeyDto } from "../domain/eurodat-key";

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends BaseService {

    //private serviceUrl = `${environment.edmUrl}/documents/`;
    private serviceUrl = `${environment.serviceBaseUrl}api/document`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getDocument(doc: AttachedFile) {
        this.loadingTask.activateLoading();

        return this.http.get(`${this.serviceUrl}/${doc.DocumentType}/${doc.PartnerCode}/${doc.DocSqlId}/${doc.DocIncId}`, this.generateHeaderForBlobDownload())
            .pipe(
                catchError(this.handleError<any>('getDocument')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }

    getMultipleReportDocuments(docList: EurodatKeyDto[]) {
        this.loadingTask.activateLoading();

        return this.http.post(`${this.serviceUrl}/report/multi`, JSON.stringify(docList), this.generateHeaderForBlobDownload())
            .pipe(
                catchError(this.handleError<any>('getMultipleDocuments')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }
    /* 
        getDocumentprev(doc: AttachedFile) {
            this.loadingTask.activateLoading();
    
            console.log(doc);
    
            return this.http.get( `${environment.edmUrl}${doc.Configuration}/documents/${doc.DocSqlId}/${doc.DocIncId}`, this.generateHeaderForFileDownloadWithToken())
              .pipe(
                catchError(this.handleError<any>('getDocument')),
                finalize(() => this.loadingTask.deactivateLoading()));
          } */

    // NEWS DESCRIPTION
    getDescription() {
        this.loadingTask.activateLoading();

        return this.http.get(`${this.serviceUrl}/generalinfo`, this.coreData.IsLoggedIn ? this.generateHeader() : this.generateHeaderWithBearer())
            .pipe(
                catchError(this.handleError<any>('getDescription')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }

    modifyDescription(text: string) {
        return this.http.put(`${this.serviceUrl}/generalinfo`, { text }, this.generateHeaderWithBearer())
            .pipe(
                catchError(this.handleError<any>('modifyDescription')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }
    //

    // NEWS FILE HANDLER
    getNewsDocumentList() {
        this.loadingTask.activateLoading();

        return this.http.get(`${this.serviceUrl}/news/all`, this.coreData.IsLoggedIn ? this.generateHeader() : this.generateHeaderWithBearer())
            .pipe(
                catchError(this.handleError<any>('getNewsDocuments')),
                finalize(() => this.loadingTask.deactivateLoading()),
                map((response: Document[]) => {
                    return response.map((item: Document) => {
                        return Document.mapFromJSON(item);
                    });
                }));
    }

    getNewsDocument(emdCode: string) {
        this.loadingTask.activateLoading();

        return this.http.get(`${this.serviceUrl}/news/${emdCode}`, this.coreData.IsLoggedIn ? this.generateHeaderForBlobDownload() : this.generateHeaderForBlobDownloadWithBearer())
            .pipe(
                catchError(this.handleError<any>('getDocument')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }

    createNewsDocument(file: File) {
        const formData: FormData = new FormData();

        formData.append('file', file, file.name);

        return this.http.request(new HttpRequest('POST', `${this.serviceUrl}/news`, formData, this.generateHeaderForFormDataWithBearer()))
            .pipe(
                catchError(this.handleError<any>('createNewsDocument')),
                map((x => x)));
    }

    deleteNewsDocument(documentCode: string) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/news/${documentCode}`, this.generateHeaderWithBearer()).pipe(
            catchError(this.handleError<any>('deleteNewsDocument')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((x: number) => x));
    }

    //
}